<template>
  <!-- 组装拆分单详情（新增/查看） -->
  <div class="make-up-order-detail">
    <list-page  :status-name="dataDetail.statusName" :status-type="dataDetail.status === 3001? 'info': 'success'">
      <list-table class="list-table" background-color="#FFF">
        <form-tag label="单据信息"/>
        <form-items :columns="3" :data="dataDetail">
          <form-item label="单据编号">
            <el-input v-model="dataDetail.billNo" placeholder="系统自动生成" disabled/>
          </form-item>
          <form-item label="单据日期">
            <el-date-picker v-model="dataDetail.billDate" type="date" value-format="YYYY-MM-DD" placeholder="选择日期" style="width:100%"/>
          </form-item>
          <form-item label="出库仓库" :required="true" name="outWarehouseId" error-message="请选择出库仓库">
            <el-select v-model="dataDetail.outWarehouseId" placeholder="请选择出库仓库">
              <el-option v-for="w in warehouseOptions" :key="w.id" :value="w.id" :label="w.warehouseName"/>
            </el-select>
          </form-item>
          <form-item label="入库仓库" :required="true" name="inWarehouseId" error-message="请选择入库仓库">
            <el-select v-model="dataDetail.inWarehouseId" placeholder="请选择入库仓库">
              <el-option v-for="w in warehouseOptions" :key="w.id" :value="w.id" :label="w.warehouseName"/>
            </el-select>
          </form-item>
          <form-item label="操作员">
            <el-input v-model="dataDetail.operatorName" disabled/>
          </form-item>
          <form-item label="部门">
            <depart-select v-model="dataDetail.departCode" :data="departTree" :disabled="isReadonly || dataDetail.status === 2" placeholder="请选择部门"/>
          </form-item>
          <form-item label="备注" :show-block="true">
            <el-input type="textarea" v-model="dataDetail.remark" placeholder="备注信息"/>
          </form-item>
        </form-items>
        <form-tag label="出库明细（从出库仓库扣减，校验库存充足）">
          <template #default>
            <el-select v-model="templateId" placeholder="请选择模板" class="template-select" @change="templateChange">
              <el-option v-for="item in templateOptions" :key="item.id" :value="item.id" :label="item.templateName"/>
            </el-select>
          </template>
        </form-tag>
        <product-select-table ref="outTable" v-model="dataDetail.outItems" :multi="true" height="auto" @table-select-multi="addList2Out">
          <yq-table-column label="批次" prop="batchNumber" width="160rem">
            <template v-slot="{row}">
              <span><el-input v-model="row.batchNumber" placeholder="请输入批次号"/></span>
            </template>
          </yq-table-column>
          <yq-table-column label="数量" prop="qty" width="130rem">
            <template v-slot="{row}">
              <el-input-number v-model="row.qty" :min="1" controls-position="right" :disabled="isReadonly" style="width:100%"/>
            </template>
          </yq-table-column>
          <yq-table-column label="基本单位" width="100rem" align="center">
            <template v-slot="{row}">{{unitName(row.unitIdBase)}}</template>
          </yq-table-column>
          <yq-table-column label="操作" width="90rem" align="center" v-if="!isReadonly">
            <template v-slot="{row, $index}">
              <table-button el-type="danger" @click="deleteOutItem($index)">移除</table-button>
            </template>
            <template #header>
              <table-button :disabled="isReadonly" @click="addOutItem"><yq-icon name="element-ui_plus"/>添加出库</table-button>
            </template>
          </yq-table-column>
        </product-select-table>

        <form-tag label="入库明细（加入入库仓库库存）"/>
        <product-select-table ref="inTable" v-model="dataDetail.inItems" :multi="true" height="auto" @table-select-multi="addList2In">
          <yq-table-column label="批次" prop="batchNumber" width="160rem">
            <template v-slot="{row}">
              <span><el-input v-model="row.batchNumber" placeholder="请输入批次号"/></span>
            </template>
          </yq-table-column>
          <yq-table-column label="数量" prop="qty" width="130rem">
            <template v-slot="{row}">
              <el-input-number v-model="row.qty" :min="1" controls-position="right" :disabled="isReadonly" style="width:100%"/>
            </template>
          </yq-table-column>
          <yq-table-column label="基本单位" width="100rem" align="center">
            <template v-slot="{row}">{{unitName(row.unitIdBase)}}</template>
          </yq-table-column>
          <yq-table-column label="操作" width="90rem" align="center" v-if="!isReadonly">
            <template v-slot="{row, $index}">
              <table-button el-type="danger" @click="deleteInItem($index)">移除</table-button>
            </template>
            <template #header>
              <table-button :disabled="isReadonly" @click="addInItem"><yq-icon name="element-ui_plus"/>添加入库</table-button>
            </template>
          </yq-table-column>
        </product-select-table>


      </list-table>

      <form-page :show-page="false" v-if="!isReadonly">
        <template #left>
          <div class="tip-info">
            💡 组装拆分不改变商品总体数量，仅形态转换及仓库间转移；出/入库仓库可为同一仓库。
          </div>
        </template>
        <page-button :disabled="dataDetail.status > 3001" type="write" el-type="primary" @click="saveData">保存草稿</page-button>
        <page-button :disabled="dataDetail.status > 3001" type="write" el-type="success" @click="submitData">提交单据</page-button>
        <page-button @click="router.go(-1)">取消</page-button>
      </form-page>
    </list-page>
  </div>
</template>

<script>
import ListPage from "@/components/h5/layout/ListPage.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import PageButton from "@/components/h5/button/PageButton.vue";
import FormTag from "@/components/h5/layout/FormTag.vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import YqIcon from "@/components/YqIcon.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import ProductSelectTable from "@/components/h5/product/ProductSelectTable.vue";
import DepartSelect from "@/components/h5/data/DepartSelect.vue";
import {useRoute, useRouter} from "vue-router";
import Util from "@/util/util";
import commonApi from "@/api/commonApi";
import assemblyOrderApi from "@/api/normal/stock/assemblyOrderApi";
import assemblyTemplateApi from "@/api/normal/stock/assemblyTemplateApi";
import stocktakeOrderApi from "@/api/normal/stock/stocktakeOrderApi";
import warehouseApi from "@/api/normal/stock/warehouseApi";
import commonDataApi from "@/api/normal/common/commonDataApi";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "MakeUpOrderDetail",
  components: {
    YqIcon, ProductSelectTable, YqTableColumn, TableButton, FormItems, FormItem, FormTag,
    DepartSelect,
    PageButton, ListPage, ListTable, FormPage
  },
  data() {
    return {
      templateOptions: [],
      warehouseOptions: [],
      departTree: [],
      unitList: [],
      dataDetail: {},
      isReadonly: false,
      templateId: "",
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  created() {
    this.init();
    let id = this.route.query.id;
    if (id) {
      this.isReadonly = this.route.query.view === '1';
      this.findById(id);
    } else {
      this.initNew();
    }
  },
  methods: {
    init() {
      // 仓库/模板下拉 + 部门树 + 单位字典
      commonDataApi.queryAllWarehouse().then(warehouses => this.warehouseOptions = warehouses);
      assemblyOrderApi.queryAllTemplate().then(templates => this.templateOptions = templates || []);
      commonApi.queryDepartList().then(departs => this.departTree = departs || []);
      commonApi.queryUniqueDictionaryList("PRODUCT_UNIT").then(units => this.unitList = units || []);
    },
    unitName(unitId) {
      if (!unitId) return "";
      let u = this.unitList.find(it => it.dictCode === unitId);
      return u ? u.dictName : "";
    },
    async findById(id) {
      const res = await assemblyOrderApi.findById(id);
      this.dataDetail = res;
      this.dataDetail.outItems = [];
      this.dataDetail.inItems = [];
      this.templateId = res.templateId || "";
      (res.itemList || []).forEach(it => {
        const row = {
          skuId: it.skuId || it.productId,
          productId: it.productId,
          productName: it.productName || "",
          unitIdBase: it.unitIdBase || it.skuUnitId,
          qty: it.qty,
          batchNumber: it.batchNumber,
        };
        if (it.direction === 2) {
          this.dataDetail.inItems.push(row);
        } else {
          this.dataDetail.outItems.push(row);
        }
      });
    },
    async initNew() {
      const user = await Util.getUserInfo();
      this.dataDetail = {
        billNo: "", templateId: "", billDate: this.today(),
        outWarehouseId: "", inWarehouseId: "", remark: "",
        operatorId: user ? user.id : "",
        operatorName: user ? user.employeeName : "",
        departCode: user ? user.mainDepartCode : "",
        outItems: [{skuId: "", productId: "", productName: "", unitIdBase: "", skuUnitId: "", qty: 1, batchNumber: ""}],
        inItems: [{skuId: "", productId: "", productName: "", unitIdBase: "", skuUnitId: "", qty: 1, batchNumber: ""}],
      };
      // 主部门唯一仓库时自动填充出/入库仓库
      if (user && user.mainDepartCode) {
        const {records} = await warehouseApi.queryList({pageNumber: 1, pageSize: 100, departCode: user.mainDepartCode});
        if (records && records.length === 1) {
          this.dataDetail.outWarehouseId = records[0].id;
          this.dataDetail.inWarehouseId = records[0].id;
        }
      }
    },
    today() {
      return new Date().toISOString().slice(0, 10);
    },
    // 选择模板后自动带出明细
    async templateChange(templateId) {
      this.dataDetail.templateId = templateId; // 同步到提交数据
      if (!templateId) {
        this.dataDetail.outItems = [{skuId: "", productId: "", productName: "", unitIdBase: "", qty: 1, batchNumber: ""}];
        this.dataDetail.inItems = [{skuId: "", productId: "", productName: "", unitIdBase: "", qty: 1, batchNumber: ""}];
        return;
      }
      const res = await assemblyTemplateApi.findById(templateId);
      this.dataDetail.outItems = [];
      this.dataDetail.inItems = [];
      (res.itemList || []).forEach(it => {
        const row = {
          skuId: it.skuId || it.productId,
          productId: it.productId,
          productName: it.productName || "",
          unitIdBase: it.unitIdBase || it.skuUnitId,
          qty: it.qty,
          batchNumber: it.batchNumber || "",
        };
        if (it.direction === 2) {
          this.dataDetail.inItems.push(row);
        } else {
          this.dataDetail.outItems.push(row);
        }
      });
    },
    addOutItem() {
      this.$refs.outTable.toSelectMore();
    },
    addInItem() {
      this.$refs.inTable.toSelectMore();
    },
    deleteOutItem(index) {
      this.dataDetail.outItems.splice(index, 1);
      this.$refs.outTable.refresh();
    },
    deleteInItem(index) {
      this.dataDetail.inItems.splice(index, 1);
      this.$refs.inTable.refresh();
    },
    addList2In(list) {
      this.fillItems(this.dataDetail.inItems, list);
    },
    // 出库明细添加商品：自动带出该商品在出库仓库的批次（FIFO），多批次拆多行
    async addList2Out(list) {
      if (!this.dataDetail.outWarehouseId) {
        this.$message.error("请先选择出库仓库");
        return;
      }
      // 1. 先填充商品信息（普通）
      this.fillItems(this.dataDetail.outItems, list);
      // 2. 收集选中的商品id，查批次
      const productIds = [];
      for (let j = 0; j < list.length; j++) {
        const pid = list[j].parentId || list[j].id;
        if (productIds.indexOf(pid) < 0) productIds.push(pid);
      }
      const batches = await stocktakeOrderApi.queryStockBatchVoByProducts(this.dataDetail.outWarehouseId, productIds);
      const batchMap = {};
      (batches || []).forEach(b => {
        const key = b.productId || b.skuId;
        if (!batchMap[key]) batchMap[key] = [];
        batchMap[key].push(b);
      });
      // 3. 对选中的出库商品，若有多批次则按批次拆分成多行
      const newOutItems = [];
      this.dataDetail.outItems.forEach(it => {
        const productBatches = batchMap[it.productId] || [];
        if (productBatches.length <= 1) {
          // 无批次或单批次，保持原行
          const batch = productBatches[0];
          if (batch) {
            it.batchId = batch.batchId;
            it.batchNumber = batch.batchNumber;
          }
          newOutItems.push(it);
        } else {
          // 多批次：按 FIFO 顺序拆成多行，每行一个批次
          productBatches.forEach(b => {
            newOutItems.push({
              skuId: it.skuId,
              productId: it.productId,
              productName: it.productName,
              unitIdBase: it.unitIdBase,
              qty: it.qty,
              batchId: b.batchId,
              batchNumber: b.batchNumber,
            });
          });
        }
      });
      this.dataDetail.outItems = newOutItems;
      this.$refs.outTable.refresh();
    },
    fillItems(items, list) {
      for (let i = 0; i < items.length; i++) {
        for (let j = 0; j < list.length; j++) {
          if (items[i].skuId === list[j].id) {
            items[i].productId = list[j].parentId || list[j].id;
            items[i].productName = list[j].productName;
            items[i].unitIdBase = list[j].unitIdBase;
            items[i].skuUnitId = list[j].unitIdBase;
            items[i].qty = items[i].qty || 1;
          }
        }
      }
    },
    buildItemList() {
      const outItems = (this.dataDetail.outItems || []).filter(it => it.skuId).map(it => ({
        productId: it.productId || it.skuId,
        skuId: it.skuId,
        skuUnitId: it.skuUnitId || it.unitIdBase,
        qty: it.qty,
        batchId: it.batchId,
        batchNumber: it.batchNumber,
        direction: 1,
      }));
      const inItems = (this.dataDetail.inItems || []).filter(it => it.skuId).map(it => ({
        productId: it.productId || it.skuId,
        skuId: it.skuId,
        skuUnitId: it.skuUnitId || it.unitIdBase,
        qty: it.qty,
        batchId: it.batchId,
        batchNumber: it.batchNumber,
        direction: 2,
      }));
      return [...outItems, ...inItems];
    },
    validate() {
      if (!this.dataDetail.outWarehouseId || !this.dataDetail.inWarehouseId) {
        this.$message.error("请选择出库/入库仓库");
        return false;
      }
      const items = this.buildItemList();
      const outItems = items.filter(it => it.direction === 1);
      const inItems = items.filter(it => it.direction === 2);
      if (outItems.length === 0 || inItems.length === 0) {
        this.$message.error("出库与入库明细均不能为空");
        return false;
      }
      return true;
    },
    saveData() {
      if (!this.validate()) return;
      const submitData = {...this.dataDetail, itemList: this.buildItemList()};
      submitData.status = 3001;
      assemblyOrderApi.save(submitData).then(() => this.router.push('/stock/makeUp'))
    },
    submitData() {
      if (!this.validate()) return;
      const submitData = {...this.dataDetail, itemList: this.buildItemList()};
      submitData.status = 3010;
      assemblyOrderApi.save(submitData).then(() => this.router.push('/stock/makeUp'))
    }
  }
};
</script>

<style lang="scss" scoped>
.make-up-order-detail {
  height: 100%;
  .list-table {
    padding: 10px;
  }
  .add-item-btn {
    border: 1.5px dashed var(--yq-border-color);
    border-radius: 6px;
    padding: 8px;
    text-align: center;
    color: var(--yq-font-color-tips);
    font-size: 13px;
    cursor: pointer;
    margin: 8px 16px;
    &:hover { color: var(--el-color-primary); border-color: var(--el-color-primary); }
  }
  .tip-info {
    font-size: 12px;
    color: var(--el-color-primary);
  }
  .template-select{
    width: 180px;
  }
}
</style>
